import { memo } from 'react';
import { Checkbox, Icon, Label, Popup, Segment } from 'semantic-ui-react';
import { NUMBER_SEPARATORS } from '../../../../constants/generalConstants';
import { useMetadataSettingsSetters, useGlobalMetadataState } from '../../../../stores/metadataStore';
import { DecimalSeparatorType, FinancialSourceType } from '../../../../types';
import { getOptions } from '../../../../utils/tableExtraction';
import { SUPPORTED_FIELD_VALUES } from '../../constants';
import LabeledDropdown from '../labeledDropdown';

const GlobalAnnotations = memo(function GlobalAnnotations() {
    const { numberFormat, scale, financialSource } = useGlobalMetadataState();
    const { changeNumberFormat, setScale, setFinancialSource } = useMetadataSettingsSetters();

    return (
        <Segment className="flex flex-align-center flex-gap-1">
            <LabeledDropdown
                label="Decimal Separator"
                placeholder="Separator"
                value={numberFormat.decimalSeparator}
                options={getOptions(NUMBER_SEPARATORS)}
                onChange={(__, data) => changeNumberFormat({ decimalSeparator: data.value as DecimalSeparatorType })}
            />
            <LabeledDropdown
                label="Select Scale"
                placeholder="Scale"
                compact
                value={scale}
                options={getOptions(SUPPORTED_FIELD_VALUES.SCALES_KVP)}
                onChange={(__, data) => setScale(data.value as number)}
            />
            <LabeledDropdown
                label="Source Type"
                placeholder="Source"
                value={financialSource}
                options={getOptions(SUPPORTED_FIELD_VALUES.FINANCIAL_SOURCES_KVP)}
                onChange={(__, data) => setFinancialSource(data.value as FinancialSourceType)}
            />
            <Checkbox
                checked={numberFormat.negateDataInBrackets}
                onChange={() => changeNumberFormat({ negateDataInBrackets: !numberFormat.negateDataInBrackets })}
                label="Negate Data in Brackets"
            />
            {!!numberFormat.warnings.length && (
                <Popup
                    content={numberFormat.warnings.join(', ')}
                    trigger={
                        <div className="ml-auto">
                            <Label color="red">Warnings</Label>
                            <Icon color="red" name="info" />
                        </div>
                    }
                />
            )}
        </Segment>
    );
});

export default GlobalAnnotations;
